module.exports = __webpack_public_path__ + "static/media/file_type_doc_error_icon.724972c8.svg";